<template>
  <div ref="trapRef" class="modal">
    <div @click="$emit('closeModal')" class="modal-background"></div>
    <div class="modal-card">  
        <header class="modal-card-head">
            <h4 class="modal-card-title"><slot name="header"></slot></h4>
        </header>
        <section class="modal-card-body">
            <slot name="content"></slot>
        </section>
        <footer class="modal-card-foot">
            <button aria-label="close"  @click="$emit('closeModal')" class="button">Close</button>
        </footer>
    </div>
  </div>
</template>

<script>
import useFocusTrap from "@/composables/useFocusTrap";

export default {
props: ['contents'],
setup(props, { emit }) {

const { trapRef } = useFocusTrap();

const modalThing = () => {
    emit('closeModal')
}

return { 
  modalThing, 
  trapRef }
}

}
</script>

<style>

</style>
